// eslint-disable-next-line import/default, import/no-named-as-default, import/no-named-as-default-member
import GameEngineUI from './GameEngineUI.js';
import { GameScene } from './Scenes/GameScene.js';

export default class GinRummyGameUI {
	constructor() {
		this.gameUI = null;
		this.game = null;
		this.gameScene = null;
	}

	async create(parentElement, options) {
		if (!options) {
			options = {
				backgroundColor: 0x000000,
				resolution: window.devicePixelRatio || 1,
				clearBeforeRender: true,
				antialias: false,
				autoDensity: true,
				backgroundAlpha: 0,
			};
		}

		if (!parentElement) {
			parentElement = 'game-canvas';
		}

		//the GameScene is designed for 500x800 stage size.  It sill resize to fit the parentElement.
		const widthStage = 500;
		const heightStage = 800;

		this.gameUI = new GameEngineUI(widthStage, heightStage, options, parentElement);

		this.gameScene = new GameScene(null, null, null);
		await this.gameUI.loadScene(this.gameScene); //promise callback.
	}

	async loadGame(game, user) {
		this.game = game;
		await this.gameUI.scene.loadGame(game, user);
	}

	destroy() {
		if (this.gameUI) {
			this.gameUI.destroy(true, true);
			this.gameUI = null;
		}

		if (this.game) {
			this.game.destroy();
			this.game = null;
		}

		this.gameScene = null;
	}

}
